(() => {
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-vw-ten-add]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    const status = form.querySelector('[data-vw-ten-status]');
    const grouped = new Map();
    for (const [key, value] of new FormData(form)) {
      const match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
      if (!match) continue;
      const item = grouped.get(match[1]) || {};
      item[match[2]] = Number(value);
      grouped.set(match[1], item);
    }
    const items = [...grouped.values()];
    if (!items.length || items.some(item => !Number.isSafeInteger(item.id) || !Number.isInteger(item.quantity) || item.quantity < 1)) {
      status.textContent = 'Please contact ViaWood to confirm this layout.';
      return;
    }
    button.disabled = true;
    status.textContent = 'Adding your sample layout…';
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'This layout could not be added. Please review availability with ViaWood.');
      window.location.assign(root + 'cart');
    } catch (error) {
      status.textContent = error.message || 'Please try again or contact ViaWood.';
      button.disabled = false;
    }
  });
})();